{
  "name": "ftv",
  "version": "5.9.0",
  "scripts": {
    "ng": "ng",
    "start": "ng serve --host=127.0.0.1 --proxy-config proxy.conf.json",
    "build": "ng build --configuration production",
    "test": "ng test"
  },
  "private": true,
  "dependencies": {
    "@angular/cdk": "22.2.1",
    "@angular/common": "22.2.1",
    "@angular/compiler": "22.2.1",
    "@angular/core": "22.2.1",
    "@angular/forms": "22.2.1",
    "@angular/material": "22.2.1",
    "@angular/platform-browser": "22.2.1",
    "@angular/router": "22.2.1",
    "@angular/service-worker": "22.2.1",
    "buffer": "^6.0.3",
    "chart.js": "^4.5.1",
    "chartjs-plugin-datalabels": "^2.2.0",
    "crypto-js": "4.2.0",
    "file-saver": "^2.0.5",
    "jspdf": "4.2.1",
    "jspdf-autotable": "5.0.8",
    "ng2-charts": "11.0.0",
    "ngx-colors": "^4.0.2",
    "ngx-image-cropper": "^9.1.7",
    "ngx-quill": "31.0.1",
    "rxjs": "7.8.2",
    "tslib": "2.8.1",
    "zone.js": "~0.16.3"
  },
  "devDependencies": {
    "@angular/build": "^22.2.1",
    "@angular/cli": "^22.2.1",
    "@angular/compiler-cli": "22.2.1",
    "@angular/language-service": "22.2.1",
    "@types/crypto-js": "4.2.2",
    "@types/file-saver": "^2.0.7",
    "@types/jasmine": "6.0.0",
    "@types/node": "24.10.1",
    "eslint": "10.9.1",
    "istanbul-lib-instrument": "^6.0.3",
    "jasmine-core": "6.0.1",
    "karma": "6.4.4",
    "karma-chrome-launcher": "3.2.0",
    "karma-jasmine": "5.1.0",
    "karma-jasmine-html-reporter": "2.2.0",
    "ts-node": "10.9.2",
    "typescript": "6.0.3"
  },
  "overrides": {
    "jspdf": {
      "dompurify": "^3.4.17"
    },
    "zod": "^4.6.7"
  }
}
